import { useEffect, useMemo, useState } from 'react';
import './ConfigNotas.scss';
import { DataGrid } from 'devextreme-react';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { useApiConfiguration } from '../../api/api.configuration';
import { Column, Editing, Form, Lookup, Popup } from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';

const typesTemplate = [
  { value: 1, text: 'VALIDACIÓN' },
  { value: 2, text: 'DESVALIDACIÓN' },
  { value: 3, text: 'INTERNAS ÓRDENES' },
  { value: 4, text: 'PLANTILLAS' },
  { value: 5, text: 'TRACKING' },
  { value: 6, text: 'ALARMAS' },
  { value: 7, text: 'BORRAR ORDEN' },
  { value: 8, text: 'PREORDENES' },
  { value: 9, text: 'RETOMAR MUESTRA' },
  { value: 10, text: 'MICROBIOLOGÍA' }
];

export default () => {
  const [data, setData] = useState<any>([]);
  const { newPlantillaNota, getPlantillasNotas, updatePlantillaNota, deletePlantillaNota } = useApiConfiguration();
  const notesEditorOptions = { height: 100 };

  const fetchData = async () => {
    try {
      const res = await getPlantillasNotas();
      setData(res);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Pln_Id',
      load: () =>
        Promise.resolve({
          data: data,
          totalCount: data.length,
        }),
      insert: async (values) => {
        return newPlantillaNota(values)
          .then((res) => {
            if (res === 105) {
              return fetchData();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el usuario');
          });
      },
      update: (key, values) => {
        const rowData = data.find((item) => item.Pln_Id === key);
        // Obtener la fila original antes de la actualización

        if (rowData) {
          // Combinar los valores actuales con los originales
          const updatedData = { ...rowData, ...values };
          return updatePlantillaNota(key, updatedData)
            .then((res) => {
              if (res === 107) {
                return fetchData();
              }
              // Devolver una promesa resuelta en caso de éxito
              return Promise.resolve();
            })
            .catch(() => {
              throw new Error('Error actualizando el usuario');
            });
        }
        // En caso de no encontrar la fila, devolver una promesa resuelta para evitar el error
        return Promise.resolve();
      },
      remove: (key) => {
        return deletePlantillaNota(key).then((res) => {
          if (res) {
            return fetchData();
          }
        });
      },
    });
  }, [data]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper view-wrapper-contact-list'>
        <DataGrid className='grid' dataSource={customDataSrc} height='100%' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
          <Editing allowAdding allowDeleting allowUpdating mode='popup'>
            <Popup title='Plantillas para notas' showTitle={true} width={700} height={'auto'} />
            <Form>
              <Item itemType='group' colCount={2} colSpan={2}>
                <Item dataField='Pln_Titulo' colSpan={2} caption='Titulo' />
                <Item dataField='Pln_Abreviatura' caption='Abreviatura' />
                <Item dataField='Pln_Tipo' caption='Tipo' />
                <Item dataField='Pln_Notas' caption='Notas' editorType='dxTextArea' colSpan={2} editorOptions={notesEditorOptions} />
              </Item>
            </Form>
          </Editing>
          <Column dataField='Pln_Id' editorOptions={{ visible: false }} caption='ID' width={50} alignment='center' />
          <Column dataField='Pln_Abreviatura' caption='Abreviatura' width={200} alignment='center' />
          <Column dataField='Pln_Titulo' caption='Titulo' />
          <Column dataField='Pln_Notas' caption='Notas' visible={false} />
          <Column dataField='Pln_Tipo' caption='Tipo' width={160} alignment='center'>
            <Lookup dataSource={typesTemplate} valueExpr='value' displayExpr='text' />
          </Column>
          <Column dataField='Pln_Estado' caption='Estado' alignment='center' dataType='boolean' width={80} />
        </DataGrid>
      </div>
    </div>
  );
};
